import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { Sponsor } from '../../../models/sponsor.model';
import { SponsorService } from '../../../services/sponsor.service';
import { NotificationService } from '../../../services/notification.service';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogManagerService } from '../../../services/dialog-manager.service';

@Component({
  selector: 'app-create-sponsor-dialog',
  standalone: true,
  imports: [
    FloatLabelModule,
    DialogModule,
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
  ],
  templateUrl: './create-sponsor-dialog.component.html',
  styleUrl: './create-sponsor-dialog.component.scss',
})
export class CreateSponsorDialogComponent implements OnInit {
  editedSponsor: Sponsor;

  constructor(
    private sponsorService: SponsorService,
    private notificationService: NotificationService,
    private dialogManager: DialogManagerService
  ) {}

  ngOnInit(): void {
    this.resetSponsorForm();
  }

  resetSponsorForm(): void {
    this.editedSponsor = {
      sponsorId: 0,
      sponsorName: '',
      contactEmail: '',
      description: '',
      phoneNumber: '',
    };
  }

  addKostentraeger(): void {
    if (!this.editedSponsor.sponsorName.trim()) {
      this.notificationService.warn(
        'Der Name des Kostenträgers darf nicht leer sein.'
      );
      return;
    }

    this.sponsorService.createSponsor(this.editedSponsor).subscribe({
      next: (createdSponsor: Sponsor) => {
        this.notificationService.success(
          `Kostenträger "${createdSponsor.sponsorName}" wurde erfolgreich hinzugefügt.`
        );
        this.closeDialog();
      },
      error: () => {
        this.notificationService.error(
          'Beim Erstellen des Kostenträgers ist ein Fehler aufgetreten.'
        );
      },
    });
  }

  closeDialog() {
    this.editedSponsor = {
      sponsorId: 0,
      sponsorName: '',
      contactEmail: '',
      description: '',
      phoneNumber: '',
    };
    this.dialogManager.closeSponsorDialog();
  }
}
